import { Reducer } from 'redux';
import { EmployeesState, EmployeesTypes } from './types';

const INITIAL_STATE: EmployeesState = {
  employeeData: {
    id: '',
    type: 0,
    name: '',
    phone: '',
    registry: '',
    document: '',
    licenseNumber: '',
    licenseType: '',
    licenseExpiration: '',
    licenseFrontPhoto: '',
    licenseBackPhoto: '',
    createdAt: '',
    updatedAt: '',
    status: '',
    testOnly: false,
  },
  employeesList: [],
  manyEmployeesList: [],
  inactiveEmployeesList: [],
  filterEmployeesList: [],
  employeesDailyReports: [],
  employeesReports: {
    '': {
      'Perfil Comum': 0,
      Externa: 0,
      'Nova politica': 0,
      'Politica de teste': 0,
      total: 0,
      comission: 0,
    },
  },
  employeeSettingsData: {
    id: '',
    days: null,
    trips: 0,
    value: 0,
    commissionType: null,
    commissionPaymentRule: null,
    commissionValue: null,
    createdAt: '',
    updatedAt: '',
    paymentMethods: null,
    hasTicketRegister: false,
  },
  employeeRestrictionList: [],
  employeeRating: [],
  selectedCollection: null,
  totalCount: 0,
  totalCountInactive: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<EmployeesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST_EMPLOYEES
    case EmployeesTypes.LIST_EMPLOYEES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeesList: INITIAL_STATE.employeesList,
      };
    case EmployeesTypes.LIST_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeesList: action.payload.employeesList,
        totalCount: action.payload.totalCount,
      };
    case EmployeesTypes.LIST_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES LIST_INACTIVE_EMPLOYEES
    case EmployeesTypes.LIST_INACTIVE_EMPLOYEES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        inactiveEmployeesList: INITIAL_STATE.inactiveEmployeesList,
      };
    case EmployeesTypes.LIST_INACTIVE_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        inactiveEmployeesList: action.payload.inactiveEmployeesList,
        totalCountInactive: action.payload.totalCountInactive,
      };
    case EmployeesTypes.LIST_INACTIVE_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES GET EMPLOYEE
    case EmployeesTypes.GET_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeeData: INITIAL_STATE.employeeData,
      };
    case EmployeesTypes.GET_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeData: action.payload.employeeData,
      };
    case EmployeesTypes.GET_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeeData: INITIAL_STATE.employeeData,
      };

    // CASES EMPLOYEE REPORT TRIP
    case EmployeesTypes.GET_EMPLOYEES_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeesReports: INITIAL_STATE.employeesReports,
      };
    case EmployeesTypes.GET_EMPLOYEES_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeesReports: action.payload.employeesReports,
      };
    case EmployeesTypes.GET_EMPLOYEES_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeesReports: INITIAL_STATE.employeesReports,
      };

    // CASES EMPLOYEE DAILY REPORT TRIP
    case EmployeesTypes.GET_EMPLOYEES_DAILY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeesDailyReports: INITIAL_STATE.employeesDailyReports,
      };
    case EmployeesTypes.GET_EMPLOYEES_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeesDailyReports: action.payload.employeesDailyReports,
      };
    case EmployeesTypes.GET_EMPLOYEES_DAILY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeesDailyReports: INITIAL_STATE.employeesDailyReports,
      };

    // CASES LIST_EMPLOYEES
    case EmployeesTypes.FILTER_EMPLOYEES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        filterEmployeesList: INITIAL_STATE.filterEmployeesList,
      };
    case EmployeesTypes.FILTER_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        filterEmployeesList: action.payload.filterEmployeesList,
        totalCount: action.payload.totalCount,
      };
    case EmployeesTypes.FILTER_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        filterEmployeesList: INITIAL_STATE.filterEmployeesList,
      };

    // CASES CREATE EMPLOYEE
    case EmployeesTypes.CREATE_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeeData: INITIAL_STATE.employeeData,
      };
    case EmployeesTypes.CREATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeData: action.payload.employeeData,
      };
    case EmployeesTypes.CREATE_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeeData: INITIAL_STATE.employeeData,
      };

    // CASES UPDATE EMPLOYEE
    case EmployeesTypes.UPDATE_EMPLOYEE_REQUEST:
      return { ...state, loading: true, error: false };
    case EmployeesTypes.UPDATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeData: action.payload.employeeData,
      };
    case EmployeesTypes.UPDATE_EMPLOYEE_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE EMPLOYEE
    case EmployeesTypes.DELETE_EMPLOYEE_REQUEST:
      return { ...state, loading: true, error: false };
    case EmployeesTypes.DELETE_EMPLOYEE_SUCCESS:
      return { ...state, loading: false, error: false };
    case EmployeesTypes.DELETE_EMPLOYEE_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE EMPLOYEE lLIST
    case EmployeesTypes.DELETE_LIST_EMPLOYEE_REQUEST:
      return { ...state, loading: true, error: false };
    case EmployeesTypes.DELETE_LIST_EMPLOYEE_SUCCESS:
      return { ...state, loading: false, error: false };
    case EmployeesTypes.DELETE_LIST_EMPLOYEE_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES CHANGE PASSWORD
    case EmployeesTypes.CHANGE_PASSWORD_REQUEST:
      return { ...state, loading: true, error: false };
    case EmployeesTypes.CHANGE_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: false };
    case EmployeesTypes.CHANGE_PASSWORD_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES EMPLOYEE ADD PAYMENT
    case EmployeesTypes.ADD_EMPLOYEE_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case EmployeesTypes.ADD_EMPLOYEE_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case EmployeesTypes.ADD_EMPLOYEE_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES EMPLOYEE REMOVE PAYMENT
    case EmployeesTypes.REMOVE_EMPLOYEE_PAYMENT_REQUEST:
      return { ...state, loading: true, error: false };
    case EmployeesTypes.REMOVE_EMPLOYEE_PAYMENT_SUCCESS:
      return { ...state, loading: false, error: false };
    case EmployeesTypes.REMOVE_EMPLOYEE_PAYMENT_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES SELECTED COLLECTION
    case EmployeesTypes.SET_SELECTED_COLLECTION:
      return {
        ...state,
        loading: true,
        error: false,
        selectedCollection: action.payload.selectedCollection,
      };

    // CASES CREATE MANY EMPLOYEE
    case EmployeesTypes.CREATE_MANY_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        manyEmployeesList: INITIAL_STATE.manyEmployeesList,
      };
    case EmployeesTypes.CREATE_MANY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        manyEmployeesList: action.payload.manyEmployeesList,
      };
    case EmployeesTypes.CREATE_MANY_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        manyEmployeesList: INITIAL_STATE.manyEmployeesList,
      };

    // CASES GET EMPLOYEE SETTINGS
    case EmployeesTypes.GET_EMPLOYEE_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeeSettingsData: INITIAL_STATE.employeeSettingsData,
      };
    case EmployeesTypes.GET_EMPLOYEE_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeSettingsData: action.payload.employeeSettingsData,
      };
    case EmployeesTypes.GET_EMPLOYEE_SETTINGS_FALURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeeSettingsData: INITIAL_STATE.employeeSettingsData,
      };

    // CASES UPDATE EMPLOYEE SETTINGS
    case EmployeesTypes.UPDATE_EMPLOYEE_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeeSettingsData: INITIAL_STATE.employeeSettingsData,
      };
    case EmployeesTypes.UPDATE_EMPLOYEE_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeSettingsData: action.payload.employeeSettingsData,
      };
    case EmployeesTypes.UPDATE_EMPLOYEE_SETTINGS_FALURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeeSettingsData: INITIAL_STATE.employeeSettingsData,
      };

    // EMPLOYEE RESTRICTION LIST
    case EmployeesTypes.EMPLOYEE_RESTRICTION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeeRestrictionList: INITIAL_STATE.employeeRestrictionList,
      };
    case EmployeesTypes.EMPLOYEE_RESTRICTION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeRestrictionList: action.payload.employeeRestrictionList,
      };
    case EmployeesTypes.EMPLOYEE_RESTRICTION_LIST_FALURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeeRestrictionList: INITIAL_STATE.employeeRestrictionList,
      };

    // EMPLOYEE RATING
    case EmployeesTypes.EMPLOYEE_RATING_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        employeeRating: INITIAL_STATE.employeeRating,
      };
    case EmployeesTypes.EMPLOYEE_RATING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeRating: action.payload.employeeRating,
      };
    case EmployeesTypes.EMPLOYEE_RATING_FALURE:
      return {
        ...state,
        loading: false,
        error: true,
        employeeRating: INITIAL_STATE.employeeRating,
      };

    default:
      return state;
  }
};

export default reducer;
